"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("../../components");
var Sorting = function () {
    var _a = (0, react_1.useState)(false), showPopover = _a[0], setShowPopover = _a[1];
    var _b = (0, react_1.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var onTogglePopover = (0, react_1.useCallback)(function () {
        setShowPopover(function (value) { return !value; });
    }, [setShowPopover]);
    var onClick = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        onTogglePopover();
        setAnchorEl(target);
    }, [setAnchorEl, onTogglePopover]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.SortingButton, { onClick: onClick }),
        showPopover && (react_1.default.createElement(components_1.SortingPopover, { anchorEl: anchorEl, onClose: onTogglePopover }))));
};
exports.default = Sorting;
